<ppl-accordion [title]="'Timesheet Summary'" [isOpen]="true">
  <p class="message">
    Please use the filters to view in-process pay periods.
  </p>
  <div class="">
    <div class="">
      <form nz-form [formGroup]="inProcessTimesheetSearchForm">
        <nz-row [nzGutter]="16">
          <nz-col nzSpan="4" [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3">
            <nz-form-item>
              <nz-form-control [nzErrorTip]="'Please enter the PA PPL ID'">
                <input placeholder="PA PPL ID" nz-input formControlName="paPplId" id="paPplId" />
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col nzSpan="4" [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="5" [nzXXl]="5">
            <nz-form-item>
              <nz-form-control [nzErrorTip]="'Please select a consumer'">
                <nz-select formControlName="paName" class="ppl-select filters" id="paName"
                  nzPlaceHolder="Personal Assistant" nzShowSearch nzAllowClear style="width: 100%;">
                  @for(opt of providers; track $index){
                  <nz-option [nzLabel]="opt.providerFullName" [nzValue]="opt.providerId"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col nzSpan="4" [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3">
            <nz-form-item>
              <nz-form-control [nzErrorTip]="'Please select a status'">
                <nz-select formControlName="status" class="ppl-select filters" id="status" nzPlaceHolder="Status"
                  nzShowSearch nzAllowClear style="width: 100%;">
                  @for(opt of inProcessFilterStatus; track $index){
                  <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col nzSpan="" [nzXs]="8" [nzSm]="8" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3">
            <ppl-button label="Search" icon="fa fa-filter" style="margin-top: -2px;" [customClass]="'primary-button'"
              [iconPosition]="'left'" (click)="inProcessTimesheetSearch()"
              *authorize="[pageId, tabId, 'AddTimeenties', 'section', 'edit']"></ppl-button>
          </nz-col>
          <nz-col nzSpan="" [nzXs]="3" [nzSm]="2" [nzMd]="1" [nzLg]="1" [nzXl]="1" [nzXXl]="1">
            <ppl-button label="" ariaLabel="Refresh" icon="fa fa-refresh" [customClass]="'primary-button'"
              [iconPosition]="'left'" (click)="loadInProgressData()"></ppl-button>
          </nz-col>
        </nz-row>
      </form>
    </div>
  </div>
  <ppl-accordion [title]="'In-Process Timesheets'" [isOpen]="true">
    @if(inProcessConsumerTimesheets.length > 0){
    @if(isMobileView) {
    <div class="card-layout">
      <div class="card" *ngFor="let row of inProcessConsumerTimesheets">
        <div class="card-item">
          <strong>{{ row.providerName }} </strong>
          <div class="status">
            {{ row.providerPplId }}
          </div>
        </div>
        <div class="card-item">
          <div class="btn-group">
            <div class="custom-row">
              <div class="mr-1">
                <ppl-button ariaLabel="View" label="View" [customClass]="'ghost-button'" [iconPosition]="'left'"
                  (click)="onAction({data: row, action: 'view'}, false)"></ppl-button>
              </div>
              <ppl-button ariaLabel="Deny" label="Deny" [customClass]="'ghost-button'" [iconPosition]="'left'"
                (click)="onAction({data: row, action: 'deny'}, false)"></ppl-button>
              <div class="mr-1">
                <ppl-button ariaLabel="Approve" label="Approve" [customClass]="'ghost-button'" [iconPosition]="'left'"
                  (click)="onAction({data: row, action: 'approve'}, false)"></ppl-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    } @else {
    <ppl-list-table #inProcessTimesheetChildComponent class="in-process"
      rowDataAccessibilityKey="tasTimesheetLineDetailId" [customDataLoaded]="true" [disableSort]="false"
      [disableSearch]="true" [showCustomSearch]="false" [enableActions]="true" [disableSelection]="true"
      [pageConfig]="programName" [sharedDataKey]="sharedDataKey" [loadPage]="true"
      [actionButtons]="actionButtonsInProcess" [data]="inProcessConsumerTimesheets"
      [columnsToBeHidden]="columnsToBeHidden" [actionsToBeHidden]="actionsToBeHidden"
      (gridAction)="onAction($event, true)" [pagination]="true" [from]="'claims'" [cols]="cols"
      (onPageLoad)="onInProcessTimesheetPageLoad($event)">
    </ppl-list-table>
    }
    }@else {
    <nz-row>
      <p>No Data found</p>
    </nz-row>
    }
  </ppl-accordion>
  <p class="message">
    Please use the filters to view previous pay periods.
  </p>
  <div class="">
    <div class="">
      <form nz-form [formGroup]="timesheetSearchForm">
        <nz-row [nzGutter]="16">
          <nz-col nzSpan="4" [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3">
            <nz-form-item>
              <nz-form-control [nzErrorTip]="'Please select a pay period'">
                <nz-select formControlName="payPeriod" class="filters" id="payPeriod" nzPlaceHolder="Pay Period"
                  nzShowSearch nzAllowClear style="width: 100%;">
                  @for(opt of payPeriod; track $index){
                  <nz-option [nzLabel]="opt.payPeriod" [nzValue]="opt"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col nzSpan="4" [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3">
            <nz-form-item>
              <nz-form-control [nzErrorTip]="'Please select a consumer'">
                <nz-select formControlName="provider" class="ppl-select filters" id="provider"
                  nzPlaceHolder="Personal Assistant" nzShowSearch nzAllowClear style="width: 100%;">
                  @for(opt of providers; track $index){
                  <nz-option [nzLabel]="opt.providerFullName" [nzValue]="opt.providerId"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col nzSpan="4" [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3">
            <nz-form-item>
              <nz-form-control [nzErrorTip]="'Please select a status'">
                <nz-select formControlName="status" class="ppl-select filters" id="status" nzPlaceHolder="Status"
                  nzShowSearch nzAllowClear style="width: 100%;">
                  @for(opt of status; track $index){
                  <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col nzSpan="" [nzXs]="8" [nzSm]="8" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3">
            <ppl-button label="Search" icon="fa fa-filter" style="margin-top: -2px;" [customClass]="'primary-button'"
              [iconPosition]="'left'" (click)="search()"
              *authorize="[pageId, tabId, 'AddTimeenties', 'section', 'edit']"></ppl-button>
          </nz-col>
          <nz-col nzSpan="" [nzXs]="3" [nzSm]="2" [nzMd]="1" [nzLg]="1" [nzXl]="1" [nzXXl]="1">
            <ppl-button label="" ariaLabel="Refresh" icon="fa fa-refresh" [customClass]="'primary-button'"
              [iconPosition]="'left'" (click)="loadProcessedData()"></ppl-button>
          </nz-col>
        </nz-row>
      </form>
    </div>
  </div>
  <ppl-accordion [title]="'Processed Timesheets'" [isOpen]="true">
    @if(processedConsumerTimesheets.length > 0){
    @if(isMobileView) {
    <div class="card-layout">
      <div class="card" *ngFor="let row of processedConsumerTimesheets">
        <div class="card-item">
          <strong>{{ row.providerName }} </strong>
          <div class="status">
            {{ row.providerPplId }}
          </div>
        </div>
        <div class="card-item">
          <div class="btn-group">
            <div class="custom-row">
              <div class="mr-1">
                <ppl-button ariaLabel="View" label="View" [customClass]="'ghost-button'" [iconPosition]="'left'"
                  (click)="onAction({data: row, action: 'view'}, true)"></ppl-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    } @else {
    <ppl-list-table #completedTimesheetChildComponent rowDataAccessibilityKey="tasTimesheetLineDetailId"
      [customDataLoaded]="true" [disableSort]="false" [disableSearch]="true" [showCustomSearch]="false"
      [enableActions]="true" [disableSelection]="true" [pageConfig]="programName" [sharedDataKey]="sharedDataKey"
      [loadPage]="true" [actionButtons]="actionButtonsProcessed" [data]="processedConsumerTimesheets"
      [columnsToBeHidden]="columnsToBeHidden" [actionsToBeHidden]="actionsToBeHidden"
      (gridAction)="onAction($event, true)" [pagination]="true" [from]="'claims'"
      [jsonList]="'list_consumer_processed_timesheet'" (onPageLoad)="onCompletedTimesheetPageLoad($event)">
    </ppl-list-table>
    }
    }@else {
    <nz-row>
      <p>No Data found</p>
    </nz-row>
    }
  </ppl-accordion>
</ppl-accordion>

<div class="filter-panel">
  <ng-template #timesheetViewDialog let-cancel="cancel">
    <ppl-timesheet-view [isProcessed]="isProcessed" [providerPplId]="providerPplId" (updated)="updated($event)"
      [consumerLineData]="consumerLineData"></ppl-timesheet-view>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #denyDialog let-cancel="cancel">
    <p>Reason: </p>
    <nz-select nzPlaceHolder="Select a Reason" [(ngModel)]="selectedReason" style="width:100%; margin-bottom: 16px"
      nzShowArrow>
      @for(item of listOfOption; track $index ){
      <nz-option [nzLabel]="item" [nzValue]="item"></nz-option>
      }
    </nz-select>
  </ng-template>
</div>